export default "__VITE_ASSET__D4Nt7eia__"